import { render, staticRenderFns } from "./QServPrizeComp.vue?vue&type=template&id=91aa6988&"
import script from "./QServPrizeComp.vue?vue&type=script&lang=js&"
export * from "./QServPrizeComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports